import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
} from '@ace-clublabs/shared-component-library';

interface EmployeeInvalidClubModalProps {
  open: boolean;
  onClose: () => void;
}

export const EmployeeInvalidClubModal = ({ open, onClose }: EmployeeInvalidClubModalProps) => {
  return (
    <Modal open={open} onClose={onClose} className="employee-invalid-club-modal" maxWidth="xs">
      <ModalTitle id={`employee-invalid-club-modal-title`} variant="h5">
        Your address is outside of the supported area
        <ModalCloseIconButton aria-label="Close" onClick={onClose} />
      </ModalTitle>

      <ModalContent id={'employee-invalid-club-modal-content'}>
        <Typography variant="b1Regular">
          This feature is not supported for your club yet. Find your club to learn more about your employee benefits.
        </Typography>
      </ModalContent>
      <ModalActions
        actionLayout={{
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'fullWidth',
          xl: 'fullWidth',
        }}
      >
        <ModalActionButton
          id="find-club-information-button"
          label="Find your club information"
          onClick={() => {
            window.open('https://clubhub.aceclubnet.com/products_services/membership/employee_memberships');
          }}
        />
      </ModalActions>
    </Modal>
  );
};
